import { camelize } from "camelscore";
import { get } from "storefront/GrailedAPI/request";
import type { Options } from "storefront/GrailedAPI/request/Options";
import type { UserSelf } from "storefront/User";

type Response = {
  data: UserSelf;
};

const unpack = (res: Response): UserSelf => camelize(res.data);

// Cloudflare returns a 403 when it challenges traffic, so we handle it alongside our own 401.
const UNAUTHENTICATED_STATUSES = [401, 403];

const me = (opts?: Options): Promise<UserSelf | undefined> =>
  get<Response>("/api/users/me", undefined, opts)
    .then(unpack)
    .catch((error) => {
      if (UNAUTHENTICATED_STATUSES.includes(error.response?.status))
        return undefined;
      throw error;
    });

export default me;
